import { ref } from 'vue';

export const content = ref<HTMLDivElement>();
